import {Splide, SplideSlide} from '@splidejs/react-splide';
import {ImageType} from '~/features/shared';

export function Gallery({images}: {images: ImageType[]}) {
  return (
    <Splide
      className="overflow-hidden bg-black rounded-3xl"
      options={{
        autoplay: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        type: 'loop',
        pagination: false,
      }}
    >
      {images.map((image, i) => {
        return (
          <SplideSlide key={i}>
            <img
              loading="eager"
              src={image.image.url}
              alt={image.image.altText}
              width={1000}
              height={560}
              className="object-cover w-full h-[24rem] md:h-[32rem]"
            />
          </SplideSlide>
        );
      })}
    </Splide>
  );
}
